var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "plus-circle-fill",
    fill: "#FFF",
    d: "M14 0C6.242 0 0 6.242 0 14s6.242 14 14 14 14-6.242 14-14S21.758 0 14 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    className: "plus-circle",
    id: "a",
    d: "M14 1.167c7.058 0 12.833 5.775 12.833 12.833S21.058 26.833 14 26.833 1.167 21.058 1.167 14 6.942 1.167 14 1.167zM14 0C6.242 0 0 6.242 0 14s6.242 14 14 14 14-6.242 14-14S21.758 0 14 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    className: "plus-plus",
    id: "b",
    d: "M22.167 13.417h-7.584V5.833c0-.35-.233-.583-.583-.583s-.583.233-.583.583v7.584H5.833c-.35 0-.583.233-.583.583s.233.583.583.583h7.584v7.584c0 .35.233.583.583.583s.583-.233.583-.583v-7.584h7.584c.35 0 .583-.233.583-.583s-.233-.583-.583-.583z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.92263ccc51a40892676debab2ce3f4df.svg";
export { ForwardRef as ReactComponent };